"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Emitter = require("./../../framework/Emitter");
var CancellationToken = function (_Emitter) {
  _inherits(CancellationToken, _Emitter);

  function CancellationToken() {
    var _this;

    _classCallCheck(this, CancellationToken);

    (_this = _possibleConstructorReturn(this, (CancellationToken.__proto__ || Object.getPrototypeOf(CancellationToken)).call(this)), _this), _this._isCanceled = !1;return _this;
  }

  _createClass(CancellationToken, [{
    key: "cancel",
    value: function cancel() {
      this._isCanceled || (this._isCanceled = !0, this.emit("canceled"));
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this._isCanceled;
    }
  }]);

  return CancellationToken;
}(Emitter);

module.exports = CancellationToken;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhbmNlbGxhdGlvblRva2VuLmpzIl0sIm5hbWVzIjpbIkVtaXR0ZXIiLCJyZXF1aXJlIiwiQ2FuY2VsbGF0aW9uVG9rZW4iLCJbb2JqZWN0IE9iamVjdF0iLCJzdXBlciIsInRoaXMiLCJfaXNDYW5jZWxlZCIsImlzQ2FuY2VsZWQiLCJlbWl0IiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFDLElBQU1BLFVBQVVDLFFBQVEsMkJBQVJBLENBQWhCO0lBRUtDLGlCOzs7QUFDRkMsK0JBQUFBO0FBQUFBOztBQUFBQTs7QUFDSUMsNklBQ0FDLE1BQUtDLFdBQUxELEdBQUtDLENBQWMsQ0FEbkJGLENBREpEO0FBS0FJOzs7OzZCQUlBSjtBQUNTRSxXQUFLQyxXQUFMRCxLQUNEQSxLQUFLQyxXQUFMRCxHQUFLQyxDQUFjLENBQW5CRCxFQUNBQSxLQUFLRyxJQUFMSCxDQUFVLFVBQVZBLENBRkNBO0FBRVM7Ozt3QkFQbEJFO0FBQ0ksYUFBT0YsS0FBS0MsV0FBWjtBQUdKSDs7OztFQVY0QkgsTzs7QUFrQmhDUyxPQUFPQyxPQUFQRCxHQUFpQlAsaUJBQWpCTyJ9